import { render, staticRenderFns } from "./ComponentspeakerDetails.vue?vue&type=template&id=6a20fd99&"
import script from "./ComponentspeakerDetails.vue?vue&type=script&lang=js&"
export * from "./ComponentspeakerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ComponentspeakerDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports